export default __webpack_public_path__ + "static/header-iconic-link-products-link-icon5.url-64728ec4b4fcb01f706a61dcecde7e53.svg";